import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import './App.css';
import Header from './componentes/header';
import Footer from './componentes/footer';
import Fcopel from './pages/fcopel';
import Prestador from './pages/fcopel/prestador';
import EnergisaPrev from './pages/energisaprev';
import Elosprev from './pages/elosprev';
import Fundaffemg from './pages/fundaffemg';
import Shark from './pages/shark';
import ScrollToTop from './componentes/scrolltop';
import 'bootstrap/dist/css/bootstrap.min.css';
// import useSmoothScroll from './componentes/scroll'


function App() {
    // useSmoothScroll()

  return (
    <Router>
          <ScrollToTop />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/fcopel" element={<Fcopel />} />
      <Route path="/prestador" element={<Prestador />} />
      <Route path="/energisaprev" element={<EnergisaPrev />} />
      <Route path="/elosprev" element={<Elosprev />} />
      <Route path="/fundaffemg" element={<Fundaffemg   />} />
      <Route path="/sharknarguiles" element={<Shark   />} />
    </Routes>
    <Footer />
  </Router>

  );
}

export default App;
